import { highlights } from '@/mocks/homeData';

const highlightImages = [
  'https://readdy.ai/api/search-image?query=Modern%20digital%20abstract%20geometric%20pattern%20with%20warm%20amber%20and%20cream%20tones%2C%20clean%20minimal%20composition%2C%20soft%20gradient%20texture%2C%20elegant%20flowing%20lines%2C%20professional%20technology%20aesthetic%2C%20subtle%20light%20effects%2C%20peaceful%20atmosphere&width=600&height=400&seq=highlight-yw91-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20coral%20and%20cream%20gradients%2C%20minimal%20geometric%20shapes%2C%20soft%20ambient%20light%2C%20clean%20professional%20design%2C%20flowing%20organic%20forms%2C%20elegant%20modern%20aesthetic%2C%20subtle%20texture%20background&width=600&height=400&seq=highlight-yw91-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Customizable%20digital%20interface%20concept%20with%20warm%20terracotta%20and%20cream%20color%20palette%2C%20modular%20design%20elements%2C%20soft%20abstract%20background%2C%20clean%20minimal%20style%2C%20professional%20atmosphere%2C%20elegant%20flowing%20composition&width=600&height=400&seq=highlight-yw91-03&orientation=landscape',
];

export default function HighlightsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            特色亮点
          </span>
          <h2
            className="text-2xl md:text-3xl font-bold text-foreground-950"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            喑网91 特色内容
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            探索喑网91的独特魅力，我们不断创新与优化，为您带来与众不同的使用体验
          </p>
        </div>
        <div className="space-y-10 md:space-y-14">
          {highlights.map((item, idx) => {
            const isEven = idx % 2 === 0;
            const imgSrc = highlightImages[idx] || highlightImages[0];
            return (
              <div
                key={idx}
                className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 md:gap-12`}
              >
                <div className="w-full lg:w-1/2">
                  <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '3/2' }}>
                    <img
                      src={imgSrc}
                      alt={`喑网91 - ${item.title}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <span className="inline-block text-xs font-bold text-primary-600 mb-2">
                    0{idx + 1}
                  </span>
                  <h3
                    className="text-xl md:text-2xl font-bold text-foreground-950 mb-3"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}